import { ApplicationElement } from '../application_element/element.js';
import style from './style.lit.css';
import icons from './icons.lit.css';

/**
 * This will render icons from 'icomoon' font
 *
 * @prop name - Name of the icon class
 */
export default class BaseIcon extends ApplicationElement {
  static styles = [icons, style];

  static properties = {
    name: { type: String, reflect: true },
  };
}

customElements.get('ef-base-icon') ||
  customElements.define('ef-base-icon', BaseIcon);
